// extracted by mini-css-extract-plugin
module.exports = {"signature-modal":"signature-modal_signature-modal__CJ16W","signatureModal":"signature-modal_signature-modal__CJ16W"};